import { visuallyHidden } from '@mui/utils';

/**
 * Shared bits for the hero building blocks (decision note 2026-10-23-hero-asset-pages).
 * Colours come from `useChartColors()`; nothing here adds to the global theme.
 */

/** Screen-reader-only text: every visual in this folder carries a text twin under this style. */
export const SR_ONLY = visuallyHidden;

/** Turns off transitions for people who asked the OS for reduced motion. No block here loops. */
export const NO_MOTION = { '@media (prefers-reduced-motion: reduce)': { transition: 'none !important' } } as const;

/** Soft rounded card used by the hero page (16px radius, calm border, no heavy shadow). */
export const HERO_CARD_SX = {
    bgcolor: 'background.paper',
    border: 1,
    borderColor: 'divider',
    borderRadius: 4,
    p: { xs: 1.5, sm: 2 },
    minWidth: 0,
} as const;

/** Clamp a ratio into 0..1; non-finite input counts as 0. */
export const clamp01 = (v: number): number => (Number.isFinite(v) ? Math.max(0, Math.min(1, v)) : 0);

/** SVG ids must be unique per mount; React's useId gives ':r1:', which is unsafe inside url(#...). */
export const svgId = (reactId: string, suffix: string): string => `h${reactId.replace(/[^A-Za-z0-9]/g, '')}-${suffix}`;
